import React from 'react'
import './AboutLaPlaza.css'
import laPlazaBg from '../../../assets/images/webp/la_plaza.webp'
import laPlazaBgShadowed from '../../../assets/images/webp/inicio_la_plaza_shadowed.webp'
import PhotoLinerV2 from '../../basic/photo-liner-v2/PhotoLinerV2'
import SafeArea from '../../basic/safe-area'
import { useI18n } from '../../../i18n/i18n'

const AboutLaPlaza: React.FC = () => {
    const { t } = useI18n()
    const [isFichaOpen, setIsFichaOpen] = React.useState(false)

    const toggleFicha = () => setIsFichaOpen((prev) => !prev)

    // preload both backgrounds once
    const usePreloadImages = (urls: string[]) => {
        React.useEffect(() => {
            urls.forEach((url) => {
                if (!url) return
                const img = new Image()
                img.src = url
            })
        }, [urls])
    }
    usePreloadImages([laPlazaBg, laPlazaBgShadowed])

    // lock body scroll when ficha is open
    React.useEffect(() => {
        if (isFichaOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }

        return () => {
            document.body.style.overflow = ''
        }
    }, [isFichaOpen])

    return (
        <>
            <div className="inicio-about-la-plaza-desktop">
                <div
                    style={{
                        backgroundImage: `url(${isFichaOpen ? laPlazaBgShadowed : laPlazaBg})`,
                    }}
                    className={`inicio-about-la-plaza-desktop-image ${isFichaOpen ? 'is-open' : ''}`}
                >
                    <PhotoLinerV2
                        title={t('home.aboutLaPlaza.title')}
                        color="#ffffff"
                        customClass="fs32 fw700"
                        absolute
                        onHoverChange={toggleFicha}
                        hovered={isFichaOpen}
                    />

                    <img
                        width={103}
                        src="https://images-extras.s3.us-east-1.amazonaws.com/logo_laplaza.png"
                        alt={t('home.aboutLaPlaza.logoAlt')}
                    />

                    <div className={'about-la-plaza-overlay' + (isFichaOpen ? ' is-visible' : '')}>
                        <SafeArea>
                            <div className="about-la-plaza-overlay-inner tal">
                                <div className="fs16 ln26">
                                    <div>{t('home.aboutLaPlaza.p1')}</div>
                                    <br />
                                    <div>{t('home.aboutLaPlaza.p2')}</div>
                                    <br />
                                    <div>{t('home.aboutLaPlaza.p3')}</div>
                                    <br />
                                    <div>{t('home.aboutLaPlaza.p4')}</div>
                                    <br />
                                    <a
                                        style={{ textDecoration: 'underline', color: 'white' }}
                                        href="https://laplaza.com.pe"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {t('home.aboutLaPlaza.websiteLabel')}
                                    </a>
                                </div>
                            </div>
                        </SafeArea>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AboutLaPlaza
